import { createSelector } from '@reduxjs/toolkit';
import { useSelector } from 'react-redux';

const selectAccount = (state) => state.account;

const selectWithCustomerId = createSelector([selectAccount], (account) => ({
  ...account,
  myCustomerId: account.user?.profile?.id,
}));

export const useAccount = () => useSelector(selectWithCustomerId);
